import * as yup from 'yup';

export interface IPublicAgent {
    id: number;
    agent_type: string;
    name: string;
    icon_image: string | null;
    address?: string | null;
    zipcode?: string | null;
    number_of_employees?: string | null;
    business_description?: string | null;
    industries_served?: Array<string> | null;
    regions_served?: Array<string> | null;
    is_sole_proprietor: boolean;
    hp_url?: string | null;
}

export interface IAgent {
    id: number;
    agent_type: string;
    name: string;
    company_code: string | null;
    regions_served: Array<string> | null;
    address: string;
    number_of_employees: string | null;
    icon_image: string | null;
    business_description: string | null;
    status: number;
    industries_served: Array<string> | null;
    is_sole_proprietor: boolean;
    hp_url: string | null;
    billing_address: string;
    billing_zipcode: string;
    billing_name: string;
    billing_phone: string;
    billing_email: string;
    private: boolean;
}

export const AGENCY = {
    value: 'AGENCY',
    label: 'M&A仲介会社',
};
export const FA = {
    value: 'FA',
    label: 'FA（ファイナンシャルアドバイザー）',
};
export const BUSINESS_ACQUISITION = {
    value: 'BUSINESS_ACQUISITION',
    label: '事業買取',
};
export const AGENT_TYPES = {
    AGENCY: AGENCY,
    FA: FA,
    BUSINESS_ACQUISITION: BUSINESS_ACQUISITION,
};

export const publicAgentSchema = yup.object({
    id: yup.number().required(),
    agent_type: yup.string().required(),
    name: yup.string().required(),
    icon_image: yup.string().nullable().defined(),
    address: yup.string().nullable(),
    number_of_employees: yup.string().required(),
    business_description: yup.string().required(),
    profit_level: yup.string().required(),
    net_assets_level: yup.string().required(),
    industries_served: yup.array().of(yup.string().required()).required(),
    regions_served: yup.array().of(yup.string().required()).required(),
    is_sole_proprietor: yup.boolean().required(),
    hp_url: yup.string().nullable(),
});
